import { CIcon } from '~/icons/types'

export const ciGlobe: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M20.8 7.7c-1.2 1.2-2.7 2.1-4.3 2.7 0 .5.1 1 .1 1.5 0 1.1-.1 2.2-.3 3.2 2-.5 3.8-1.4 5.5-2.5v-.8c0-1.3-.4-2.8-1-4.1ZM9 10.9V12c0 1.2.1 2.4.4 3.6.9.1 1.7.2 2.6.2.9 0 1.8-.1 2.6-.2.2-1.1.4-2.3.4-3.6v-1.1c-1 .2-1.9.3-3 .3s-2-.1-3-.3Zm3 6.3c-.8 0-1.5 0-2.2-.1.5 1.7 1.3 3.2 2.2 4.6 1-1.4 1.7-2.9 2.2-4.6-.7.1-1.4.1-2.2.1ZM7.5 12c0-.5 0-1 .1-1.5-1.7-.6-3.1-1.6-4.4-2.8-.6 1.3-1 2.7-1 4.3v.8c1.6 1.1 3.5 2 5.5 2.5-.1-1.1-.2-2.2-.2-3.3Zm6.4 9.6c3.6-.7 6.5-3.4 7.5-6.8-1.7 1-3.5 1.7-5.5 2.1-.5 1.6-1.2 3.2-2 4.7ZM2.6 14.8c1 3.5 3.9 6.1 7.5 6.8-.9-1.5-1.5-3-2-4.7-1.9-.5-3.8-1.2-5.5-2.1ZM20 6.4c-1.4-2-3.6-3.5-6.1-4 1.2 2 2 4.2 2.4 6.5 1.4-.6 2.6-1.4 3.7-2.5Zm-8 3.3c1 0 1.9-.1 2.8-.4-.4-2.6-1.4-5-2.8-7.1-1.4 2.1-2.4 4.5-2.8 7.1.9.3 1.8.4 2.8.4Zm-1.9-7.3c-2.5.5-4.7 2-6.1 4 1.1 1.1 2.3 1.9 3.7 2.5.4-2.3 1.3-4.5 2.4-6.5Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'globe',
  type: 'solid'
}
